import { useLanguage } from "../context/LanguageContext";
import PolicyPage, { type PolicyContent } from "./PolicyPage";
import { CONTACT_EMAIL } from "../data/contact";

const CONTENT: Record<"ru" | "kz", PolicyContent> = {
  ru: {
    title: "Гарантия и условия возврата",
    updated: "Дата последнего обновления: 31 августа 2026 г.",
    intro: [
      "BARCRAFT работает в сегменте B2B — настоящая политика описывает гарантийные обязательства на поставляемое оборудование и условия возврата в рамках договора поставки.",
    ],
    sections: [
      {
        heading: "1. Гарантийные обязательства",
        paragraphs: [
          "На все поставляемое оборудование предоставляется гарантия сроком 12 месяцев.",
          "Условие сохранения гарантии: оборудование должно проходить регулярное техническое обслуживание не реже одного раза в месяц силами специализированной организации. В случае отсутствия обслуживания Поставщик имеет право отказать в гарантийном ремонте.",
          `При выявлении заводского брака мы обеспечиваем ремонт или замену неисправных компонентов. Рекламации принимаются на почту: ${CONTACT_EMAIL}.`,
        ],
      },
      {
        heading: "2. Условия возврата",
        paragraphs: [
          "Мы работаем в сегменте B2B. Возврат товара надлежащего качества по причине «не подошел» или «передумали» не предусмотрен.",
          "Штрафные санкции: в случае отказа от предварительно оплаченного товара, находящегося в процессе доставки (в дороге), Покупатель уплачивает штраф в размере 30% от стоимости оборудования для покрытия логистических и операционных издержек (согласно п. 6.4 Договора).",
        ],
      },
      {
        heading: "3. Контакты",
        paragraphs: [`По вопросам гарантии и рекламаций обращайтесь: ${CONTACT_EMAIL}.`],
      },
    ],
  },
  kz: {
    title: "Кепілдік және қайтару шарттары",
    updated: "Соңғы жаңарту күні: 2026 жылғы 31 тамыз",
    intro: [
      "BARCRAFT B2B сегментінде жұмыс істейді — осы саясат жеткізілетін жабдыққа кепілдік міндеттемелерін және жеткізу шарты аясында қайтару талаптарын сипаттайды.",
    ],
    sections: [
      {
        heading: "1. Кепілдік міндеттемелері",
        paragraphs: [
          "Жеткізілетін барлық жабдыққа 12 ай мерзімге кепілдік беріледі.",
          "Кепілдікті сақтау шарты: жабдық мамандандырылған ұйым күшімен айына кемінде бір рет тұрақты техникалық қызмет көрсетуден өтуі тиіс. Қызмет көрсетілмеген жағдайда Жеткізуші кепілдіктік жөндеуден бас тартуға құқылы.",
          `Зауыттық ақау анықталған жағдайда біз ақаулы бөлшектерді жөндеуді немесе ауыстыруды қамтамасыз етеміз. Шағымдар мына поштаға қабылданады: ${CONTACT_EMAIL}.`,
        ],
      },
      {
        heading: "2. Қайтару шарттары",
        paragraphs: [
          "Біз B2B сегментінде жұмыс істейміз. Сапасы тиісті тауарды «сай келмеді» немесе «ойымды өзгерттім» себебімен қайтару қарастырылмаған.",
          "Айыппұл санкциялары: жеткізу процесінде тұрған (жолдағы) алдын ала төленген тауардан бас тартылған жағдайда, Сатып алушы логистикалық және операциялық шығындарды жабу үшін жабдық құнының 30% мөлшерінде айыппұл төлейді (Шарттың 6.4-тармағына сәйкес).",
        ],
      },
      {
        heading: "3. Байланыс",
        paragraphs: [`Кепілдік пен шағымдар бойынша хабарласыңыз: ${CONTACT_EMAIL}.`],
      },
    ],
  },
};

export default function RefundPolicyPage() {
  const { language } = useLanguage();
  return <PolicyPage content={CONTENT[language]} />;
}
